import { IconButton, Theme, Tooltip } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { keyframes } from 'tss-react';
import { makeStyles } from 'tss-react/mui';
import { IssueAction, IssueDetails } from '../../types/issues-types';

const IssueCardAction: FC<IssueActionProps> = ({
  onClick,
  text,
  icon: Icon,
  disabled,
  highlight,
  issueId,
}) => {
  const { classes, cx } = useStyles();
  const [shouldHighlight, setShouldHighlight] = useState(false);

  useEffect(() => {
    setShouldHighlight(highlight);
  }, [issueId, highlight]);

  return (
    <Tooltip arrow placement='top' title={text}>
      <div className={classes.centerIcon}>
        <IconButton
          color='primary'
          onClick={onClick}
          size={text !== 'Open PR' ? 'small' : 'medium'}
          className={cx(classes.button, shouldHighlight && classes.highlighted)}
          onAnimationEnd={() => setShouldHighlight(false)}
          disabled={disabled}>
          <Icon />
        </IconButton>
      </div>
    </Tooltip>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  button: {
    '&:hover': {
      backgroundColor:
        theme.palette.mode === 'light'
          ? 'rgba(104, 55, 255, 0.1)'
          : 'rgba(104, 55, 255, 0.2)',
    },
  },
  highlighted: {
    animation: `${keyframes`
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.5);
      }
      100% {
        transform: scale(1);
      }
      `} 2s`,
  },
  centerIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export interface IssueActionProps extends IssueAction {
  issueId: IssueDetails['id'];
}

export default IssueCardAction;
